import './App.css';
import Routes from "./Routes/Routes";
import "./assets/css/style.bundle.css";
import "./assets/plugins/global/plugins.bundle.css";
import "./assets/plugins/custom/vis-timeline/vis-timeline.bundle.css";
import "./assets/plugins/custom/datatables/datatables.bundle.css";
import {Provider} from "react-redux";
import store from './store/store';
import AxiosBootstrap from "./bootstrap/AxiosBootstrap";
import 'datatables.net-bs5';
import {PersistGate} from 'redux-persist/integration/react'
import {persistStore} from 'redux-persist'
import "./assets/css/style.css";
import DatatablesBootstrap from './bootstrap/DatatablesBootstrap';

let persistor = persistStore(store);

function App() {
    return (
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <AxiosBootstrap/>
                <DatatablesBootstrap />
                <div className="d-flex flex-column flex-root h-100">
                    <Routes/>
                </div>
            </PersistGate>
        </Provider>
    );
}

export default App;
